import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { CaretDown, Check } from '@phosphor-icons/react';
import cn from 'classnames';
import { aclHelper } from 'helper';

import { useCreateModal } from 'partial/components/Modal';
import Status from '../modals/Status';

const statusData = [
  {
    id: 0,
    title: 'active',
    description: 'The user will be able to access the following portal.',
    isActive: 1,
  },
  {
    id: 1,
    title: 'deactivate',
    description:
      'Users will not be access the provider portal. The prompt message "Unable to Access. Please contact the System Administrator".',
    isActive: 0,
  },
];

const StatusButton = ({ userDetails }) => {
  const createModal = useCreateModal();
  const status = userDetails?.is_active;
  const canUpdate = aclHelper('user', 'u');

  const [isShown, setShown] = useState(false);

  const handleStatus = useCallback(() => {
    createModal({
      content: (onClose) => (
        <Status onClose={onClose} data={userDetails} setShown={setShown} />
      ),
    });
  }, [createModal, userDetails]);

  return (
    <div className="relative">
      <button
        className={cn(
          'h-9 px-3 inline-flex gap-2 rounded items-center border font-semibold text-sm transition-colors',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 focus-visible:ring-offset-2',
          status
            ? 'border-neutral-300 text-neutral-800 hover:bg-neutral-100'
            : 'border-neutral-300 text-neutral-500 hover:bg-neutral-100',
          canUpdate ? 'cursor-pointer' : 'cursor-default',
        )}
        type="button"
        aria-haspopup="menu"
        aria-expanded={isShown}
        onClick={() => (canUpdate ? setShown(!isShown) : {})}
      >
        <span
          className={cn(
            'w-1.5 h-1.5 rounded-full',
            status ? 'bg-success-500' : 'bg-danger-500',
          )}
          aria-hidden="true"
        />
        <span>{status ? 'Active' : 'Inactive'}</span>
        {canUpdate && <CaretDown size={14} className="text-neutral-500" />}
      </button>
      {isShown && (
        <ul className="absolute top-full mt-1 right-0 z-10 w-[300px] overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-popover">
          {statusData?.map(({ id, title, description, isActive }) => (
            <li key={id}>
              <button
                type="button"
                onClick={() => handleStatus()}
                disabled={status === isActive}
                className={cn(
                  'p-3 w-full text-left transition-colors',
                  'focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-600',
                  isActive === status
                    ? 'bg-neutral-50 cursor-default'
                    : 'hover:bg-neutral-100',
                )}
              >
                <h5 className="capitalize font-semibold text-sm text-neutral-900 mb-1 flex gap-1.5 items-center">
                  <span>{title}</span>
                  {userDetails?.status === title && (
                    <Check size={14} weight="bold" className="text-brand-600" />
                  )}
                </h5>
                <p className="text-xs text-neutral-500">{description}</p>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

StatusButton.propTypes = {
  userDetails: PropTypes.instanceOf(Object).isRequired,
};

export default StatusButton;
